﻿// WBCM
const handleGiftAidDisplayForDonationType = () => {
    $('.ui-button-text a.question, .js-option-trigger').on('click', function (e) {
        if (document.querySelector('input[name="Donation.DonationType"]:checked').value == 'OneOff' || document.querySelector('input[name="Donation.DonationType"]:checked').value == 'Regular') {
            $('.gift-toggle-content').show();
            $('.gift-toggle-content').removeClass('hidden');
        } else if (document.querySelector('input[name="Donation.DonationType"]:checked').value == 'Event') {
            $('.gift-toggle-content').hide();
            $('.gift-toggle-content').addClass('hidden');
        }

        // Native replacement for the removed jQuery UI button("refresh") call:
        // set the checked property/attribute directly and notify listeners via a change event.
        $(this).parents('div.tooltip').find('input').prop('checked', true).attr('checked', 'checked').trigger('change');
    });
}

/**
 * Selects the donation type based on the provided payment type.
 * 
 * This function sets the value of the '#typeOfDonation' element to the specified
 * payment type, stores the payment type in session storage under the key 'donationType',
 * and submits the 'DonationType' form.
 * 
 * @param {string} paymentType - The type of payment to be set as the donation type.
 */
const selectDonationType = (paymentType) => {
    $('#typeOfDonation').val(paymentType);
    sessionStorage.setItem('donationType', paymentType);
    document.forms["DonationType"].submit();
}

/**
 * Initializes event listeners for donation type selection.
 * 
 * Attaches click and keydown event handlers to elements with the class 
 * 'js-donation__cards--card'. On click or pressing 'Enter', retrieves the 
 * 'data-paymenttype' attribute from the clicked element and calls 
 * `selectDonationType` with the retrieved payment type to proceed to the 
 * next step in the donation process.
 */
const setDonationTypeandSubmit = () => {
    // On click of donation type option selection, reach to next step 
    $('.js-donation__cards--card').on('click', function (e) {
        e.preventDefault();
        const paymentType = $(this).attr('data-paymenttype');
        selectDonationType(paymentType);
    });
    // On keydown of donation type option selection, reach to next step
    $(".js-donation__cards--card").on('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            const paymentType = $(this).attr('data-paymenttype');
            selectDonationType(paymentType);
        }
    });
}

/**
 * Updates the display and accessibility of elements related to the "In Memory Of" section
 * when the corresponding checkbox is selected. It shows and styles specific labels and inputs,
 * sets the tabindex for the "Other Relationship" input, and ensures the relationship dropdown
 * is visible.
 */
const checkInMemoryOfSelected = () => {
    $('input#IsInMemoryOfSomeone_true:checked')
        .closest('.row.memory')
        .find('.relations')
        .addClass('display')
        .find('input#InMemoryOf')
        .siblings('label[for=InMemoryOf], label[for=InMemoryRelationship] ')
        .css('display', 'inline')
        .siblings('input#InMemoryOf')
        .css('display', 'block')
        .closest('.row.memory')
        .find('select#InMemoryRelationship').show();

}

/**
 * Toggles the display of the 'otherRelation' element based on the selected value
 * of the 'InMemoryRelationship' dropdown. If the value is "Other", the 'otherRelation'
 * element is displayed. Additionally, sets up event listeners on the 
 * '#IsInMemoryOfSomeone_true' checkbox to trigger the same display logic on click 
 * or change events.
 */
const checkMemoryRelationshipOther = () => {
    const el = $('input#IsInMemoryOfSomeone_true:checked')
        .closest('.row.memory')
        .find('select#InMemoryRelationship');

    if ($(el).val() === "Other") {
        $('.otherRelation').css('display', 'block')
    }

    const inMemoryOfTrue = $('#IsInMemoryOfSomeone_true');
    inMemoryOfTrue.on('click change', function () {
        if ($(el).val() === "Other") {
            $('.otherRelation').css('display', 'block')
        }
    })
}

/**
 * Toggles the display of terms and conditions when the associated element is clicked.
 * Updates the 'aria-expanded' attribute to reflect the current state of the terms and conditions.
 * Also toggles the 'show' class on the terms and conditions container and the 'expanded' class on the accordion icon.
 * This only fires when the button is visible in mobile view
 */
const handleTermsDisplay = () => {
    // Step 3 Regular - Reveal terms and condition
    $('#display-terms-and-conditions').on('click', function (e) {
        e.preventDefault();
        const expandedState = $(this).attr('aria-expanded');

        if (expandedState === 'false') {
            $(this).attr('aria-expanded', 'true');
        } else {
            $(this).attr('aria-expanded', 'false');
        }

        $('.terms-and-conditions').toggleClass('show');
        $('.accordian-expand-icon').toggleClass('expanded');
    })
}

/**
 * Attaches an input event handler to elements with the class 'js-amount-input'.
 * The handler performs the following actions:
 * - Debounces the validation check by 500ms to improve performance.
 * - Validates the input value using the jQuery validation plugin.
 * - Removes leading zeros from whole numbers to ensure proper formatting.
 */
const handleAmountInput = () => {
    // When user types into the amount input box: check if the input is valid and delay the check by 500ms
    let debounceTimer;
    $('.js-amount-input').on('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            $(this).valid();
        }, 500);

        let val = $(this).val();

        // Remove leading zero for whole numbers
        if (/^0\d+/.test(val)) {
            $(this).val(val.replace(/^0+/, ''));
        }
    });
}

/**
 * Updates the selected donation amount based on user interaction.
 * 
 * This function retrieves all elements with the class 'donationAmountItem'
 * and attaches a click event listener to each. When an item is clicked,
 * it updates the donation amount in the input box using the organization's
 * utility function. It also validates the donation amount input field
 * within the appropriate form.
 */
const updateAmountSelected = () => {
    // Get node list of all amount items
    let amountSelectorItems = document.querySelectorAll('.donationAmountItem');
    // When user clicks amount item: update the amount in the input box
    Array.prototype.forEach.call(amountSelectorItems, function (selectorItem) {
        selectorItem.addEventListener('click', function (e) {

            macmillan.utils.updateMobileAmount(e);

            $('#DonationTypeAndAmount')[0] ? $('#DonationTypeAndAmount').validate().element('#Donation_Payment_Amount') : $('form.wbcmform').validate().element('#Donation_Payment_Amount');
        })
    })
}

/**
 * Check for a value in the custom amount field and if there is a value, check if there is a corresponding custom amount.
 * If there is a corresponding custom amount, select that custom amount and display the corresponding impact card.
 * This is to ensure that if the user selects a custom amount, then goes back a page and then forward again, 
 * the correct custom amount will be selected and the correct impact card will be shown based on the custom amount they have entered.
 */
const checkCustomAmountSelected = () => {
    let amount = $('.js-amount-input').val();
    if  (!amount) return;
    // Check for a corresponding custom amount
    const presetAmount = $('.js-amount-radio-input').filter(function() {
        return $(this).val() === amount;
    });
    // If there is a corresponding custom amount, select that custom amount
    if (presetAmount.length) {
        presetAmount.prop('checked', true).trigger('change');
    }
    let selectedRadio = $(".js-amount-radio-input:checked");
    let selectedValue = selectedRadio.val();
    $('.js-amount-impact-card').each(function () {
        if ($(this).data('amount') == selectedValue) {
            $(this).removeClass('hidden');
        } else {
            $(this).addClass('hidden');
        }
    });
}

/**
 * Binds event handlers to input elements for donation amount selection and input.
 * 
 * - Handles 'keydown' events on elements with class '.js-amount-radio-input' to
 *   trigger a change event when the 'Enter' key is pressed.
 * - Handles 'click' and 'touchend' events on elements with class '.js-amount-radio-input'
 *   to trigger a change event.
 * - Handles 'change' events on elements with class '.js-amount-radio-input' to update
 *   the selected radio button, set aria attributes, and update related input fields.
 * - Handles 'change' events on elements with class '.js-amount-input' to update the
 *   hidden input and visible input values and reset radio button selections.
 * - Handles 'focusout' events on elements with class '.js-amount-input' to update the
 *   hidden input value.
 */
const bindAmountInputEvents = () => {
    $('body')
        // Handle keypress events for donation amount selection
        .on('keydown', '.js-amount-radio-input', function (e) {
            if (e.key === "Enter") {
                // Prevent default behavior
                e.preventDefault();
                // Trigger change event
                $(this).prop("checked", true).trigger("change");
            }
        })
        // Handle click events for donation amount selection
        .on('click touchend', '.js-amount-radio-input', function (e) {
            // Prevent default behavior
            e.preventDefault();
            // Trigger change event
            $(this).prop("checked", true).trigger("change");
        })
        // Handle change events for donation amount selection
        .on('change', '.js-amount-radio-input', function () {
            // Get selected radio
            let selectedRadio = $(".js-amount-radio-input:checked");
            // Get value of selected radio
            let selectedValue = selectedRadio.val();

            // Reset all radios
            $(".js-amount-radio-input").attr("aria-checked", "false").removeAttr("checked");
            $(".js-amount-label-as-button").removeClass("selected");

            // Set checked and aria-checked on selected radio
            if (selectedRadio.length) {
                selectedRadio.attr("aria-checked", "true").prop("checked", true);
                selectedRadio.siblings("label").addClass("selected");
                // Update the donation input field
                $('.js-amount-input, .js-amount-input-hidden').val(selectedValue);

                // Mark input as valid to remove errors
                $('.js-amount-input').valid();
            }
            $('.js-amount-impact-card').each(function () {
                if ($(this).data('amount') == selectedValue) {
                    $(this).removeClass('hidden');
                } else {
                    $(this).addClass('hidden');
                }
            });
        })
        // Handle change events for donation amount input
        .on('change', '.js-amount-input', function (e) {
            // Get value of input as amount
            let amount = e.target.value;
            // Get all buttons which are actually labels
            let buttons = $('.js-amount-label-as-button');
            // Reset all radios
            $.each(buttons, function (i, button) {
                $(button).removeClass('selected');
            });
            // Set the value of the amount to the hidden input and visible input
            $('.js-amount-input-hidden, .js-amount-input').val(amount);

        })
        .on('focusout', '.js-amount-input', function (e) {
            // Prevent default behavior
            e.stopPropagation();
            // Get value of input as amount
            let amount = e.target.value;
            // Set the value of the amount to the hidden input
            $('.js-amount-input-hidden').val(amount);
        })
        .on('input', '.js-amount-input', function (e) {
            $('.js-amount-impact-card').each(function () {
                $(this).addClass('hidden');
            });
            // Uncheck all preset radio inputs
            $('.js-amount-radio-input').prop('checked', false).attr('aria-checked', 'false');
            // Remove selected class from all labels
            $('.js-amount-label-as-button').removeClass('selected');
        })
}

/**
 * Attaches a click event handler to custom checkbox elements, allowing them to toggle
 * their checked state. When a custom checkbox is clicked, this function updates the
 * associated input element's checked property and dispatches a native change event.
 */
const makeCustomCheckboxClickable = () => {
    // Make custom checkbox span element clickable
    $('span.checkbox--custom').on('click', function () {
        let checkbox = $(this).closest('.custom-checkbox').find('input[type=checkbox]');
        checkbox.prop('checked', !checkbox.prop('checked'));
        // Dispatch native change event so both jQuery and addEventListener handlers fire
        checkbox[0].dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Ensure labels associated with custom checkboxes toggle correctly
    // despite jQuery UI button widget interference
    $('.custom-checkbox input[type=checkbox]').each((i, input) => {
        const label = document.querySelector('label[for="' + input.id + '"]');
        if (label) {
            $(label).on('click', function (e) {
                e.preventDefault();
                $(input).prop('checked', !input.checked);
                input.dispatchEvent(new Event('change', { bubbles: true }));
            });
        }
    });
}

/**
 * Handles the click event for Gift Aid card elements.
 * 
 * This function manages the selection state of tax payer inputs by removing
 * the 'selected' class from all elements and toggling it on the clicked element.
 * It also ensures that clicking on the Gift Aid text triggers the checked state
 * of the associated input, mimicking label behavior.
 */
const handleGiftAidCardClick = () => {
    // Remove seleced class from all tax payer inputs
    function clearSelectedState() {
        $.each($('.taxPayer'), function () {
            $(this).removeClass('selected');
        })
    }

    $('.taxPayerInput').on('click', function () {
        clearSelectedState();
        $(this).closest('.taxPayer').toggleClass('selected');
    })

    // Allow Gift Aid text to trigger checked state to mimic label behavior
    $('.taxPayer').on('click', function (e) {
        let $this = $(this);

        clearSelectedState();
        $this.addClass('selected').removeClass('errorbox').siblings('.taxPayer--false').removeClass('errorbox').find('.messagebox').hide();
        let radioButton = ($this.find('input.taxPayerInput'));
        radioButton.attr('checked', 'checked');
    })
}

/**
 * Binds event handlers to elements related to the "In Memory Of" feature.
 * 
 * This function attaches change event listeners to handle the display and
 * accessibility of elements based on user interactions with radio buttons
 * and a select dropdown. When a radio button within the '.memory' class
 * is changed, it toggles the visibility and tab index of elements within
 * the '.relations' class based on the selected value. Additionally, it
 * manages the display of the '#InMemoryRelationship' element. When the
 * '#InMemoryRelationship' dropdown changes, it shows or hides the
 * '.otherRelation' element depending on the selected option.
 */
const bindInMemoryOfEvents = () => {
    $('body')
        .on('change', '.memory input[type="radio"]', function (e) {
            e.stopPropagation();
            let relations = $('.relations');

            if (e.target.value === 'true') {
                relations.addClass('display')
                    .children()
                    .not('.otherRelation')
                    .show();
                $('#InMemoryRelationship').show();
            } else {
                relations.removeClass('display').children()
                    .hide();
                $('#InMemoryRelationship').show();
            }
        })
        .on('change', '#InMemoryRelationship', function (e) {

            if (e.target.value == "Other") {
                $('.otherRelation').show();
            } else {
                $('.otherRelation').hide();
            }
        })
}

/**
 * Sets the 'tabIndex' attribute to -1 for all child elements of elements with the class 'relations',
 * making them unfocusable via keyboard navigation.
 */
const makeRelationsElementsFocusable = () => {
    $('.relations').children().attr({ 'tabIndex': -1 });
}

const bindEvents = () => {
    handleGiftAidDisplayForDonationType();
    setDonationTypeandSubmit();
    checkInMemoryOfSelected();
    checkMemoryRelationshipOther();
    handleTermsDisplay();
    handleAmountInput();
    updateAmountSelected();
    bindAmountInputEvents();
    bindInMemoryOfEvents();
    makeCustomCheckboxClickable();
    handleGiftAidCardClick();
    checkCustomAmountSelected();
}

const resetPageDefaults = () => {
    // Reset page defaults
    if ($('#InMemoryRelationship').val() === 'other_value') {
        $('.inmemoryrelationship-other').removeClass('js-hidden');
    }

    if ($('#CelebrationForRelationship').val() === 'other_value') {
        $('.incelebrationrelationship-other').removeClass('js-hidden');
    }

    if ($('#InCelebrationOf').val() === 'other_value') {
        $('.incelebration-other').removeClass('js-hidden');
    }
}

export const initDonationAmount = () => {
    bindEvents();
    resetPageDefaults();
};
